<template>
  <div class="back-button no-highlight-select">
    <button @click="onClick" style="z-index: 10;" class="relative">
      <icon-back />
    </button>
  </div>
</template>

<script>
import IconBack from "../icons/IconBack";
export default {
  name: "BackButton",
  components: { IconBack },
  props: {
    backAction: {
      type: Function,
      default: null
    },
    returnPath: String
  },
  methods: {
    onClick() {
      if (this.backAction != null) {
        this.backAction();
        return;
      } else if (this.returnPath) {
        this.$router.push({ name: this.returnPath });
      } else if (window.history.state === null) {
        this.$router.replace("/government");
      } else {
        this.$router.back();
      }
    }
  }
};
</script>

<style scoped>
.back-button {
  font-size: 1.375rem !important;
}
.back-button > button {
  z-index: 10;
}
@media screen and (min-width: 768px) {
  .back-button {
    font-size: 1.53125rem !important;
  }
}
</style>
